// extracted by mini-css-extract-plugin
export var divider = "_dh-7";
export var itemsToggle = "_dh-8";
export var mergeModal = "_dh-1";
export var optionCard = "_dh-4";
export var radioGroup = "_dh-6";
export var radioOption = "_dh-0";
export var selected = "_dh-5";
export var shipmentOptions = "_dh-2";
export var tableOptions = "_dh-3";